<template>
  <div class="in-layout">
    <user-toolbar :showSearch="false" />
    <v-content>
      <v-container>
        <router-view />
      </v-container>
    </v-content>
  </div>
</template>

<script>
import UserToolbar from '@/components/user-toolbar/UserToolbar';
import DocgoSnackbar from '@/components/base/DocgoSnackbar';

export default {
  name: 'user-layout',
  components: {
    UserToolbar,
    DocgoSnackbar,
  },
  mounted() {
    this.$store.dispatch('getUser');
  },
};
</script>

<style scoped lang="scss">
.in-layout {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/layouts/InLayout.vue